<template>
  <div>
    <p>
      Mostrar
      <router-link
        :to="`/${$t('rPaths.account')}/${$t('mEditionMenu.account.notifications.subject')}/${$t('mEditionMenu.account.notifications.children.configuration.subedition')}`"
        class="font-weight-bold text-color-academy-primary"
      >
        acceso
      </router-link>
      a configuración de notificaciones</p>
    <p>Mostrar listado de notificaciones por categoría.</p>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAccountNotifications'
}
</script>
